<div class="card card-primary card-outline style">
    <p class="style1">
         <b>{{name}}</b>
       </p>
 
       <div *ngFor="let c of output">
 
         <table class="table style">
         
         <tbody>
         

       
           <tr>
           <td><b>User Name :</b></td>
           <td>{{c.submitted_person_name}}</td>
           </tr>
 
           <tr>
           <td><b>Warehouse Name :</b></td>
           <td>{{c.warehouse_name}}</td>
           </tr>

           <tr>
            <td style="width: 30%"><b>Created Date And Time :</b></td>
            <td>{{DateFormat(c.created_date)}}</td>
            </tr>
 
         </tbody>
     </table>    
     <p class="style2">
        <b>Product List:</b>
        
          <div class="space" *ngFor="let d of c.product_lists">
          <div (click)='productDetails();getValue(c.product_id);'>
            <strong class="distance1">Product Name:</strong>{{d.product_name}}<br>
            <strong class="distance2">Product Count:</strong>{{d.product_count}}
           
          </div>
            <hr>  
 
 
